<template>
    <button type="button" @click="open = !open">
        <CountryFlag :country="selectedCountry.iso2" />
        +{{ selectedCountry.dialCode }}
        <SlideOver :show="open" @close="open = false">
            <input
                type="text"
                v-model.trim="search"
                :placeholder="$t('messages.search')"
                class="w-full border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />

            <div class="border border-b" v-if="search === ''">
                <ul class="mt-3">
                    <li v-for="country in preferredCountries" :key="country.iso2">
                        <button @click="selectCountry(country)" class="flex space-x-1 mt-1">
                            <CountryFlag :country="country.iso2" />
                            <span>
                                {{ country.name }}
                            </span>
                            <span class="text-gray-500"> (+{{ country.dialCode }}) </span>
                        </button>
                    </li>
                </ul>
            </div>

            <ul class="mt-3">
                <li v-for="country in filteredCountries" :key="country.iso2">
                    <button @click="selectCountry(country)" class="flex space-x-1 mt-1">
                        <CountryFlag :country="country.iso2" />
                        <span>
                            {{ country.name }}
                        </span>
                        <span class="text-gray-500"> (+{{ country.dialCode }}) </span>
                    </button>
                </li>
            </ul>
        </SlideOver>
    </button>
</template>
<script>
import allCountries from '@/utils/countryPhonePrefixes';
import CountryFlag from 'vue-country-flag-next';
import deburr from 'lodash/deburr';
import SlideOver from '@/components/SlideOver.vue';

export default {
    emits: ['update:modelValue'],
    name: 'PhonePrefixSelector',
    components: {
        SlideOver,
        CountryFlag,
    },
    props: {
        modelValue: {
            required: false,
        },
    },
    data() {
        return {
            search: '',
            preferred: ['ES'],
            open: false,
        };
    },
    methods: {
        selectCountry(country) {
            let x = country;
            this.$emit('update:modelValue', x.dialCode);
            this.open = false;
        },
    },
    computed: {
        selectedCountry: function () {
            return this.countries.find((country) => country.dialCode === this.modelValue);
        },
        preferredCountries: function () {
            return this.countries.filter((country) => {
                return this.preferred.includes(country.iso2.toUpperCase());
            });
        },
        filteredCountries: function () {
            if (this.search.trim() === '') {
                return this.countries;
            }

            return this.countries.filter((country) => {
                const searchStringWithoutAccents = deburr(this.search.trim().toUpperCase());
                const nameWithoutAccents = deburr(country.name.toUpperCase());

                return nameWithoutAccents.indexOf(searchStringWithoutAccents) !== -1;
            });
        },
    },
    created() {
        this.countries = allCountries.map(([iso2, dialCode]) => ({
            name: this.$t('countries.' + iso2.toUpperCase()),
            iso2,
            dialCode,
        }));
    },
};
</script>
